// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-copy\"> <i class=\"fa fa-copy\"></i> Copy </a> ";
// Exports
export default code;